/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSidebarButtons_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly favorites?: {
        readonly " $fragmentRefs": FragmentRefs<"FollowButton_favoritesConnection">;
    } | null | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactDealerButton_user" | "PdpSharedMakeOfferButton_user">;
    readonly " $refType": "PdpRespSidebarButtons_user";
};
export type PdpRespSidebarButtons_user$data = PdpRespSidebarButtons_user;
export type PdpRespSidebarButtons_user$key = {
    readonly " $data"?: PdpRespSidebarButtons_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarButtons_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchFollowSearch"
    },
    {
      "kind": "RootArgument",
      "name": "followSearchPages"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarButtons_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedMakeOfferButton_user"
    },
    {
      "condition": "fetchFollowSearch",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1
            },
            {
              "kind": "Variable",
              "name": "pages",
              "variableName": "followSearchPages"
            },
            {
              "kind": "Literal",
              "name": "types",
              "value": [
                "SEARCH",
                "USER_PREFERENCE"
              ]
            }
          ],
          "concreteType": "favoritesConnection",
          "kind": "LinkedField",
          "name": "favorites",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "FollowButton_favoritesConnection"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '2a21a72d4fdcfb11d38cc7c4afa936f1';
export default node;
